import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DateField
} from 'react-admin';

function ArticuloList(props: any) {
  useEffect(() => {
    document.title = 'Listado de Artículos';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <FunctionField
          source="imagen_cubierta"
          render={(record: any) => (
            <img
              src={record.imagen_cubierta.url}
              alt={record.imagen_cubierta.alternativeText}
              style={{ width: '120px', height: 'auto' }}
            />
          )}
        />
        <TextField source="titulo" />
        <DateField source="fecha" />
        <TextField source="autor" />
      </Datagrid>
    </List>
  )
}

export default ArticuloList;